import * as React from 'react';
import InvChoices from './InvChoices/InvChoicesButtons';
import InvChoicesSlider from './InvChoices/InvChoicesSlider';
import { FundTypes } from '../../models';
import Timeframe from './Timeframe/Timeframe';
import InvAmount from './InvAmount/InvAmount';
import Tabs from '../Tabs';
import { i18n } from '../../i18n';

interface ControlsProps {
  capitalFundSelected: FundTypes | null;
  digitalFundSelected: FundTypes | null;
  allocation: number;
  duration: number;
  monthlyContribution: number;
  lumpSum: number;
  setLumpSum: (x: number) => object;
  setMonthlyContribution: (x: number) => object;
  setDigitalFund: (x: FundTypes) => object;
  setCapitalFund: (x: FundTypes) => object;
  setAllocation: (x: number) => object;
  setDuration: (x: number) => object;
}

export default (props: ControlsProps) => (
  <Tabs>
    <div data-label={i18n.t('tool.inv_choices.tab_heading')}>
      <div className='inv-choices-wrap'>
        <h6 className='desktop-title'>{i18n.t('tool.inv_choices.heading')}</h6>
        <InvChoices
          capitalFundSelected={props.capitalFundSelected}
          digitalFundSelected={props.digitalFundSelected}
          setDigitalFund={props.setDigitalFund}
          setCapitalFund={props.setCapitalFund}
        />
        <InvChoicesSlider
          allocation={props.allocation}
          setAllocation={props.setAllocation}
          enabled={!!(props.capitalFundSelected && props.digitalFundSelected)}
        />
      </div>
    </div>
    <div data-label={i18n.t('tool.inv_amount.tab_heading')}>
      <h6 className='desktop-title'>{i18n.t('tool.inv_amount.heading')}</h6>
      <InvAmount
        lumpSum={props.lumpSum}
        monthlyContribution={props.monthlyContribution}
        setLumpSum={props.setLumpSum}
        setMonthlyContribution={props.setMonthlyContribution}
      />
    </div>
    <div data-label={i18n.t('tool.inv_timeframe.tab_heading')}>
      <h6 className='desktop-title'>{i18n.t('tool.inv_timeframe.heading')}</h6>
      <Timeframe
        duration={props.duration}
        setDuration={props.setDuration}
      />
    </div>
  </Tabs>
);
